import { render, staticRenderFns } from "./PopupPanel.vue?vue&type=template&id=6fd6f5f2&"
import script from "./PopupPanel.vue?vue&type=script&lang=js&"
export * from "./PopupPanel.vue?vue&type=script&lang=js&"
import style0 from "./PopupPanel.vue?vue&type=style&index=0&id=6fd6f5f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports